import React, { Component } from "react";
import Pdf from "react-to-pdf";
import { toast } from "react-toastify";
import { Image, Button } from "react-bootstrap";
import { Paper } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { formatNumber } from "../services/util";

import logo from "../assets/images/logo-color.png";
import { getInvoice } from "../services/saleService";
import { getCurrentUser } from "../services/authService";

const ref = React.createRef();
const options = {
  orientation: "landscape",
  unit: "in",
  format: [11, 8],
};

class Invoice extends Component {
  state = {
    invoice: {},
  };

  async componentDidMount() {
    const { match } = this.props;
    const invoiceId = match.params.id;

    try {
      const { data } = await getInvoice(invoiceId, getCurrentUser().category);
      this.setState({ invoice: data });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  }

  renderInvoiceStatus() {
    if (this.state.invoice.status === "Paid" && this.state.invoice.amountPayable <= 0) {
      return <span class="badge badge-success">PAID</span>;
    } else {
      return <span class="badge badge-warning">UNPAID</span>;
    }
  }

  render() {
    return (
      <div>
        {this.state.invoice && (
          <Pdf targetRef={ref} filename={`${this.state.invoice.invoiceNumber}.pdf`} options={options}>
            {({ toPdf }) => (
              <Button variant="success" onClick={toPdf}>
                Download PDF
              </Button>
            )}
          </Pdf>
        )}
        <Paper elevation={3}>
          <div className="invoiceContainer" ref={ref}>
            <div className="row invoice-header">
              <div className="col-md">
                <Image className="logo" src={logo} fluid />
              </div>
              <div className="col-md">
                <div className="float-right">
                  <h2>#{this.state.invoice.invoiceNumber}</h2>
                  <p className="float-right">{this.state.invoice.invoiceDate}</p>
                </div>
              </div>
            </div>
            <hr style={{ margin: "20px" }} />
            <div className="row invoice-address">
              <div className="col-md">
                <b>From: SmartCiti Fiber</b>
                <p>Plot 18, Block XV, Kolapo Ishola GRA, Akobo, Ibadan, Oyo State Nigeria</p>
                <p>Phone: 07001122333</p>
                <p>Email: sales@smartciti.com.ng</p>
              </div>
              {this.state.invoice.user && (
                <div className="col-md">
                  <b>To: {this.state.invoice.user.fullName}</b>
                  <p>{this.state.invoice.user.address}</p>
                  <p>Phone: {this.state.invoice.user.phone}</p>
                  <p>Email: {this.state.invoice.user.email}</p>
                </div>
              )}
              <div className="col-md">
                <div className="text-right">
                  <h5>Payment Details</h5>
                  {this.state.invoice.transactionDate && <p>{this.state.invoice.transactionDate}</p>}
                  <p>Total Amount: NGN {formatNumber(this.state.invoice.amountPayed)}</p>
                  <p>Balance Due: NGN {formatNumber(this.state.invoice.amountPayable)}</p>
                </div>
              </div>
            </div>
            <hr />
            <TableContainer>
              <Table size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell>Item</TableCell>
                    <TableCell align="right">Price</TableCell>
                    <TableCell align="right">Quantity</TableCell>
                    <TableCell align="right">Total Price</TableCell>
                  </TableRow>
                </TableHead>
                {this.state.invoice.items && (
                  <TableBody>
                    {this.state.invoice.items.map((item) => (
                      <TableRow key={item._id}>
                        <TableCell component="th" scope="row">
                          {item.name}
                        </TableCell>
                        <TableCell align="right">{formatNumber(item.price)}</TableCell>
                        <TableCell align="right">{formatNumber(item.quantity)}</TableCell>
                        <TableCell align="right">{formatNumber(item.amount)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <div className="row" style={{ padding: "15px", marginTop: "30px" }}>
              <div className="col-md">
                <h3>{this.renderInvoiceStatus()}</h3>
              </div>
              <div className="col-md">
                <div className="text-right">
                  <b>Total: NGN {formatNumber(this.state.invoice.invoiceTotal)}</b>
                </div>
              </div>
            </div>
          </div>
        </Paper>
      </div>
    );
  }
}

export default Invoice;
